
import React, { useState, useEffect } from "react";
import MaterialTable from '@material-table/core';
import createPersistedState from 'use-persisted-state';
import { useHistory } from 'react-router-dom';
import { ExportCsv } from "@material-table/exporters";
import { Banner } from '../../template/Banner'

const usePageSizeState = createPersistedState('pageSize');

function Places() {
  let history = useHistory();
  const [pageSize, setPageSize] = usePageSizeState(10);

  const [data, setData] = useState();

  useEffect(() => {
    function fetchPageData() {
      fetch("http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/places")
      .then(res => res.json())
      .then(result => setData(result))
      .catch(console.log);
    }
    fetchPageData();
  }, []);

  return (
    <div className="places">
    
      <Banner />
      <div className="page-box-tab">            
        <button className="tablinks link-places active" onClick={() => { history.push('/places') }}><img src="location.png" alt="" />Places</button>
        <button className="tablinks link-works" onClick={() => { history.push('/works') }}><img src="publishing.png" alt="" />Works</button>
        <button className="tablinks link-people" onClick={() => { history.push('/persons') }}><img src="profile.png" alt="" />People</button>
        <button className="tablinks link-simple-search inactive" onClick={() => { history.push('/search') }}><img src="search.png" alt="" />Simple search</button>
        <button className="tablinks link-adv-search inactive" onClick={() => { history.push('/search/advanced') }}><img src="advanced.png" alt="" />Advanced search</button>
      </div>

      <div class="registry-page-container"> 
        <div class="page-header">
          <img src="register-location.png" alt="" />
          <h1>Places</h1>
        </div>
        <div>

          <MaterialTable
            columns={[
              { title: "ID", field: "id" },
              { title: "Name", field: "place_name"},
              { title: "Number of works connected", field: "publ_num" },
              { title: "Number of persons in station connected", field: "occpers_num" }
            ]}
            data={data}
            options={{
              columnsButton: true,
              pageSize: pageSize,
              exportAllData: true,
              exportMenu: [
                {
                  label: "Export CSV",
                  exportFunc: (cols, datas) => ExportCsv(cols, datas, "persons"),
                },
              ],
              headerStyle: {
                backgroundColor: '#1b437e',
                color: '#FFF'
              },
            }}
            title=""
            onRowsPerPageChange={newPageSize => {
              setPageSize(newPageSize);
            }}
            onRowClick={((evt, selectedRow) => {
              history.push('place/' + selectedRow.id)
            })}
          />
        </div>
      </div>
    </div>
  );
}

export default Places;